import React, { useEffect, useState } from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { Switch } from 'react-router-dom';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import configureStore, { history } from './redux/store';
import AppWrapper from './@jumbo/components/AppWrapper';
import AppContextProvider from './@jumbo/components/contextProvider/AppContextProvider';
import Routes from './routes';
import 'global-styles.css';

//microsoft Graph api
import { MsalProvider } from '@azure/msal-react';
import { IPublicClientApplication } from '@azure/msal-browser';
import ProvideAppContext from './microsoft-context/AppContext';
import ErrorMessage from './microsoft-context/ErrorMessage';

//npm install react-image-lightbox
import 'react-image-lightbox/style.css';
import MicrofodtAuthWrapper from './microsoft-context/MicrosoftAuthConfig';
import { ToastProvider } from 'context/tostifyContext';
import { AllUserProvider } from 'context/AllUserDataContext';
import { CheckVersion } from 'versions/CheckVersion';

export const store = configureStore();

// const App = ({ pca }) => (
const App = ({ pca }) => {
  // const [token, setToken] = useState(JSON.parse(localStorage.getItem('token')));
  // <MicrofodtAuthWrapper>
  {
    /* <MsalProvider instance={pca}> */
  }
  {
    /* <ProvideAppContext> */
  }

  useEffect(() => {
    CheckVersion();
    const interval = setInterval(CheckVersion, 900000);
    return () => clearInterval(interval);
  }, []);

  return (
    // <MicrofodtAuthWrapper>
    <Provider store={store}>
      <ToastProvider>
        <AllUserProvider>
          <ConnectedRouter history={history}>
            <AppContextProvider>
              <AppWrapper>
                <Switch>
                  <Routes />
                </Switch>
                {/* </SignalRContext.Provider> */}
              </AppWrapper>
            </AppContextProvider>
          </ConnectedRouter>
        </AllUserProvider>
      </ToastProvider>
    </Provider>
    // </MicrofodtAuthWrapper>
  );
  {
    /* </ProvideAppContext> */
  }
  {
    /* </MsalProvider> */
  }
  // </MicrofodtAuthWrapper>
};

export default App;
